module.exports = {
  first: "#4f95d0",
  firstLight: "#5fb4e6",
  firstSuperLight: "#d6e2f4",
  firstDark: "#563E57",
  accent: "#FF6633",
  bright: "#ffffff",
  light: "#f3f3f3",
  dark: "#52607a",
  superDark: "#23355b"
};



// WEBPACK FOOTER //
// ./src/styles/colors.js